import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RoomInfo } from '../room-info'
import { usePlanStore } from '../../../store/planStore'
import { CheckInDate } from './CheckInDates'
import { PlanType, RoomType } from './type'
import { useLpAvailabilityPageStore } from '../../../store/lpAvailabilityPageStore'

export type PlanGroupType = {
  roomId: number
  // [FB-76] 部屋なしプラン（宿泊なし / School Fee Only）は room を持たない
  room?: RoomType | null
  plans: PlanType[]
}

// noAccommodation はグループのラベル（宿泊なし）から導出され、PlanList から prop として渡される
export const PlanGroup = (props: { planGroup: PlanGroupType; noAccommodation: boolean }) => {
  const { planGroup, noAccommodation } = props
  const { room, plans } = planGroup
  const [isOpenDetail, setIsOpenDetail] = useState(false)
  const { t } = useTranslation()
  const { selectedPlan, selectedCheckInDate } = usePlanStore()
  const { isJpe } = useLpAvailabilityPageStore()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const hasBirthdays = urlParams.has('birthdays')
    if (!selectedPlan || !selectedCheckInDate || !hasBirthdays) return

    const targetPlan = plans.find((p) => p.planId === selectedPlan.planId)
    if (!targetPlan) return

    const checkInDateAvailable = targetPlan.checkInDates.find((d) => d.date === selectedCheckInDate.date)
    const elementAlert = document.getElementById('check-in-date-alert')
    if (!elementAlert) return

    // [#2925] 「問い合わせ」の日を選んで生年月日を入れ、問い合わせのままなら満枠ではない
    if (!checkInDateAvailable || (checkInDateAvailable.status !== 'OK' && checkInDateAvailable.status !== '-')) {
      elementAlert.classList.remove('hidden')
    } else {
      elementAlert.classList.add('hidden')
    }
  }, [selectedPlan, selectedCheckInDate, plans])

  // [FB-76] 部屋なしプラン（noAccommodation かつ room=null）はチェックイン枠のみ表示する。
  // room がある通常プランで万一 room が欠落した場合は従来通り描画しない。
  if (!room && !noAccommodation) return <></>

  return (
    <>
      {room && isOpenDetail && <RoomInfo room={room} close={() => setIsOpenDetail(false)} />}

      {!noAccommodation && room && (
        <div className="flex gap-15px items-center justify-start ml-3 md:ml-0 mb-4">
          <img src={room.photos[0]?.url} alt={room.name} className="w-full h-auto" style={{ width: '120px' }} />
          <div className="flex flex-col justify-between">
            <div className="text-green font-bold underline mb-2 cursor-pointer" onClick={() => setIsOpenDetail(true)}>
              {room.name}
            </div>
            {!isJpe && (
              <div className="flex gap-2">
                <div className="bg-gray-200 px-2 py-1 rounded-md text-xs">
                  {t('landing_page.avaiability.room.max_capacity', { count: room.roomMaxCount, adult_count: room.adultMaxCount })}
                </div>
                {room.food && (
                  <div className="bg-gray-200 p-1 rounded-md text-xs">
                    {t('landing_page.avaiability.room.food_text', { food: room.food })}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {plans.map((plan) => (
        <div key={`planGroup-${plan.planId}`}>
          {plan.subPlanName && <div className="text-xs mt-3">{plan.subPlanName}</div>}
          <div key={plan.planId} className="flex gap-2 overflow-auto mt-2 mb-6 px-3 md:pl-0 md:pr-3">
            {plan.checkInDates.map((checkInDate) => (
              <CheckInDate plan={plan} checkInDate={checkInDate} key={`${plan.planId}-${checkInDate.date}`} />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}
